import { ClientApi } from './Request';

const Reviews = {
    employee: (data) =>
        ClientApi.post('/review_site/employee_review/add/', data),
    service: (data) => ClientApi.post('/review_site/service_review/add/', data),
};

export default Reviews;
